import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { formatPrismicData } from '@monofront/business/utils';
import { default as DefaultInformativeBox } from '@monofront/design-system/components/InformativeBox';
import getThemeColor from '@monofront/design-system/utils/getThemeColor';
import { RichText } from 'prismic-reactjs';
import CustomPrismicLink from '@monofront/design-system/prismic-link/CustomPrismicLink';
import { PrismicRichTextInjecter } from '../../helpers';
import { ISearchProduct, UnknownObject } from '@monofront/types';

import type { JSX } from "react";

/**
 * Props for `InformativeBox`.
 */
export type InformativeBoxProps =
  SliceComponentProps<Content.InformativeBoxSlice>;

/**
 * Component for "InformativeBox" Slices.
 */
const InformativeBox = ({
  prismicContent,
  slice,
  props,
}: {
  prismicContent: InformativeBoxProps;
  slice: InformativeBoxProps;
  props: UnknownObject;
}): JSX.Element => {
  const content = formatPrismicData(prismicContent || slice);
  const product = props?.product as Partial<ISearchProduct>;

  return (
    <section
      data-slice-type={content.slice_type}
      data-slice-variation={content.variation}
      className="informative-box"
    >
      <DefaultInformativeBox
        backgroundColor={getThemeColor(content.primary.backgroundColor)}
        img={{
          ...content.primary.image,
          dimensions: {
            width: content.primary.image?.dimensions.width || 48,
            height: content.primary.image?.dimensions.height || 48,
          },
          url: content.primary.image?.url || '',
          alt: content.primary.image?.alt || '',
        }}
      >
        <RichText
          render={content.primary.text}
          htmlSerializer={PrismicRichTextInjecter({
            '%CALCULATED_PERCENT_PRICE%':
              product && product?.compare_at_price && product?.price
                ? `${(
                    ((product?.compare_at_price - product?.price) /
                      product?.compare_at_price) *
                    100
                  ).toFixed(0)}%`
                : '',
          })}
          serializeHyperlink={CustomPrismicLink}
        />
      </DefaultInformativeBox>
    </section>
  );
};

export default InformativeBox;
